import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-report',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  jobId: string;

  constructor(
    private route: ActivatedRoute,
    ) {
    this.route.params.subscribe(params => {
      this.jobId = params['jobId'];
    });
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/reports/reports.component.ts